<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_Message')"
      @close="innerVisible=false"
    >
      <div class="app-main-inner-row row-grid">
        <el-input
          v-model="messageText"
          type="textarea"
          disabled
          :rows="10"
        />
      </div>
      <div slot="footer">
        <el-button type="primary" size="mini" @click="innerVisible=false">{{ $t('FinanceManage.Confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'ShowMessageDialog',
  props: {
    visible: { type: Boolean, required: true },
    messageText: { type: String, required: false, default: '' }
  },
  data() {
    return {
      loading: false,
      innerVisible: false
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
.el-loading-mask.is-fullscreen {
  z-index: 999999 !important;
}
</style>

